import { render, staticRenderFns } from "./TelessaudeIcon.vue?vue&type=template&id=ca1d4594"
import script from "./TelessaudeIcon.vue?vue&type=script&lang=js"
export * from "./TelessaudeIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports